import {
  GET_LEGALBRIDGE,
  GET_LEGALBRIDGE_SUCCESS,
  GET_LEGALBRIDGE_FAIL,
  DELETE_LEGALBRIDGE,
  DELETE_LEGALBRIDGE_SUCCESS,
  DELETE_LEGALBRIDGE_FAIL,
  UPDATE_LEGALBRIDGE,
  UPDATE_LEGALBRIDGE_SUCCESS,
  UPDATE_LEGALBRIDGE_FAIL,
  ADD_NEW_LEGALBRIDGE,
  ADD_LEGALBRIDGE_SUCCESS,
  ADD_LEGALBRIDGE_FAIL,
  LEGALBRIDGE_LOADING,
  LEGALBRIDGE_RESET
} from "./actionType";

export const resetLegalBridgeState = (actionType) => ({
  type: LEGALBRIDGE_RESET,
  payload: { actionType },
});

export const getLegalBridgeSuccess = (actionType, data) => ({
  type: GET_LEGALBRIDGE_SUCCESS,
  payload: { actionType, data },
});

export const getLegalBridgeFail = (actionType, error) => ({
  type: GET_LEGALBRIDGE_FAIL,
  payload: { actionType, error },
});

export const getLegalBridge = data => ({
  type: GET_LEGALBRIDGE,
  payload: data,
});

export const getLegalBridgeLoading = () => ({
  type: LEGALBRIDGE_LOADING
});

export const deleteLegalBridge = data => ({
  type: DELETE_LEGALBRIDGE,
  payload: data,
});

export const deleteLegalBridgeSuccess = data => ({
  type: DELETE_LEGALBRIDGE_SUCCESS,
  payload: data,
});

export const deleteLegalBridgeFail = error => ({
  type: DELETE_LEGALBRIDGE_FAIL,
  payload: error,
});

export const updateLegalBridge = data => ({
  type: UPDATE_LEGALBRIDGE,
  payload: data,
});

export const updateLegalBridgeFail = error => ({
  type: UPDATE_LEGALBRIDGE_FAIL,
  payload: error,
});

export const updateLegalBridgeSuccess = data => ({
  type: UPDATE_LEGALBRIDGE_SUCCESS,
  payload: data,
});

export const addNewLegalBridge = data => ({
  type: ADD_NEW_LEGALBRIDGE,
  payload: data,
});

export const addLegalBridgeSuccess = data => ({
  type: ADD_LEGALBRIDGE_SUCCESS,
  payload: data,
});

export const addLegalBridgeFail = error => ({
  type: ADD_LEGALBRIDGE_FAIL,
  payload: error,
});